<template>
  <div class="">
    <!-- <div class="p-3" style="background-color: var(--corelightcolor); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h1 class="section-title">Race Log</h1>
    </div> -->
    <div class="pt-3 pl-3 pb-2" style="background-color: var(--bootstrapgrey); border-bottom-left-radius: 0px; border-top-left-radius: 0px;">
      <h3 class="section-title" style="text-transform: uppercase; font-weight: 400; color: #000;">Race Log</h3>
    </div>
    <!-- <button @click="addRace">Add Race</button> -->
    <button class="btn btn-primary mt-2 mb-2 ml-1" @click="showModal">+ Add Race</button>

    <!-- Add Race Modal -->
    <!-- <div class="modal fade" id="addRaceModal" tabindex="-1" role="dialog" aria-labelledby="addRaceModalLongTitle" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addRaceModalLongTitle">Add Race</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <strong>Description</strong>
          </div>
          <div class="modal-footer">
            <button>Save</button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- End of Add Race modal -->

    <!-- HIDING THIS, NOT USING IT, RELYING ON THE MODAL -->
    <!-- Add Race Form -->
    <div style="display: none;">
    <div class="accordion mt-2" :class="{ myrundash: !team || team == 'myrundash', MDI: team == 'MDI' }">
      <div class="header" style="padding-left: 12px;" v-on:click="toggle">
        <slot name="header">+ Add Race</slot>
        <i class="fa fa-2x fa-angle-down header-icon" v-bind:class="{ rotate: show }"></i>
      </div>
      <transition name="accordion"
        v-on:before-enter="beforeEnter" v-on:enter="enter"
        v-on:before-leave="beforeLeave" v-on:leave="leave">
        <div class="body" v-show="show">
          <div class="body-inner">
            <!-- <slot></slot> -->
            <!-- <accordion> -->
              <form action="" class="pr-4">
                <div class="form-row">
                  <div class="form-group col-md-6" :class="{ invalid: $v.raceName.$invalid && saveClicked }">
                    <label for="raceName">Race Name*</label>
                    <input type="text" class="form-control" id="raceName" placeholder="What's the name of the event?" v-model="raceName">
                    <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small>
                  </div>
                </div>
                <!-- NOT USING IT, RELYING ON THE MODAL -->
                <div class="form-row">
                  <div class="form-group col-md-3" :class="{ invalid: $v.raceDate.$invalid && saveClicked }">
                    <label for="raceDate">Race Date*</label>
                    <!-- <div style="line-height: 1;">
                      <small>Si no tienes todavía una fecha de inicio, deja este campo en blanco</small>
                    </div> -->
                    <!-- https://www.npmjs.com/package/vuejs-datepicker -->
                    <!-- https://codesandbox.io/s/mpklq49wp -->
                    <datepicker class="form-control" placeholder="Select Date" v-model="raceDate" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
                    <small v-if="$v.raceDate.$invalid && saveClicked">The race date is required.</small>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="raceType">Race Type</label>
                    <select class="form-control" id="raceType" v-model="raceType">
                      <option>5k</option>
                      <option>10k</option>
                      <option>Half Marathon</option>
                      <option>Marathon</option>
                      <option>Custom</option>
                    </select>
                  </div>
                  <!-- <div class="form-group col-md-6">
                    <label for="raceType">Race Type</label>
                    <select class="form-control" id="raceType" v-model="raceType">
                      <option>5k</option>
                      <option>10k</option>
                      <option>Half Marathon</option>
                      <option>Marathon</option>
                      <option>Custom</option>
                    </select>
                  </div> -->
                  <div class="col-md-4">
                    <label for="">Finishing Time</label>
                    <div class="form-row">
                      <div class="col-lg-4 col-md-4 input-group" style="padding-right: 0;">
                        <input type="number" class="form-control" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4 input-group" style="padding-left: 0; padding-right: 0;">
                        <input type="number" class="form-control" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                        <div class="input-group-append">
                          <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4" style="padding-left: 0; padding-right: 30px;">
                        <input type="number" class="form-control" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                      </div>
                    </div>
                  </div>
                  <!-- NOT USING IT, RELYING ON THE MODAL -->
                  <div class="form-group col-md-2">
                    <label for="">Personal Best</label>
                    <div>
                      <input type="checkbox" id="PBcheckbox" v-model="personalBest">
                      <label for="PBcheckbox" class="ml-1 mt-1">Yes!</label>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-if="raceType == 'Custom'">
                  <div class="form-group col-md-6">
                    <!-- <label for="raceDistance">Distance</label> -->
                    <input type="text" class="form-control" id="raceDistance" placeholder="Distance" v-model="raceDistance">
                    <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                  </div>
                  <div class="form-group col-md-6" style="max-width: 100px;">
                    <select class="form-control" id="" v-model="distanceUnits">
                      <option>km</option>
                      <option>mi</option>
                    </select>
                  </div>
                </div>
                <!-- NOT USING IT, RELYING ON THE MODAL -->
                <div class="form-row">
                  <div class="col-lg-3 col-md-6" style="padding-right: 0;">
                    <label for="overallRank">Overall Rank</label>
                    <div class="form-group input-group" :class="{ 'invalid': checkInteger(weight) }">
                      <input type="text" class="form-control" id="overallRank" v-model="overallRank">
                      <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
                      </div>
                      <small v-if="checkInteger(overallRank)">Must be an integer!</small>
                    </div>

                  </div>
                  <div class="form-group col-lg-3 col-md-6" style="padding-left: 0;">
                    <label for="overallCompetitors" style="padding-left: 5px;">Overall Competitors</label>
                    <input type="number" class="form-control" id="overallCompetitors" placeholder="How many people in the race?" v-model="overallCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                    <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                  </div>
                  <div class="col-lg-3 col-md-6" style="padding-right: 0;">
                    <label for="ageRank">Age Category Rank</label>
                    <div class="form-group input-group">
                      <input type="number" class="form-control" id="ageRank" placeholder="" v-model="ageRank">
                      <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                      <div class="input-group-append">
                        <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
                      </div>
                    </div>
                  </div>
                  <!-- NOT USING IT, RELYING ON THE MODAL -->
                  <div class="form-group col-lg-3 col-md-6" style="padding-left: 0;">
                    <label for="ageCompetitors" style="padding-left: 5px;">Age Category Competitors</label>
                    <input type="number" class="form-control" id="ageCompetitors" placeholder="" v-model="ageCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                    <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label for="raceLink">Race Link</label>
                    <input type="text" class="form-control" id="raceLink" placeholder="Link to the race info page" v-model="raceLink">
                    <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                  </div>
                  <div class="form-group col-md-6">
                    <label for="resultsLink">Results Link</label>
                    <input type="text" class="form-control" id="resultsLink" placeholder="Link to the race results page" v-model="resultsLink">
                    <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="notes">Notes</label>
                    <textarea class="form-control" id="notes" rows="3" v-model="notes" placeholder="Anything notworthy about the event or your performance! Weather conditions, any injuries you experienced or were dealing with, people you met, things you learned, etc."></textarea>
                  </div>
                </div>
                <button class="btn btn-primary" @click.prevent="saveRace">Save</button>
              </form>
            <!-- </accordion> -->
          </div>
        </div>
      </transition>
    </div>
    <!-- NOT USING IT, RELYING ON THE MODAL -->
    </div>
    <!-- End of ADD RACE form -->

    <div v-if="pastRaces[0]">
    <div v-for="race in pastRaces" :key="race.id" style="overflow-wrap: break-word; cursor: pointer;" @click="showEditModal(race)">
      <div class="pt-3 pb-1 px-3 mb-1" :class="{ PB: race.personal_best, notPB: !race.personal_best }" style="border-bottom: 1px solid var(--bootstrapgrey);">

        <!-- <small @click="showEditModal(race)" style="cursor: pointer;">{{ race.date }} <img src="../../assets/img/icons/edit_icon_simple.svg" width='12px' alt="edit" class='ml-1 mb-1' style="" id=""></small> -->
        <h5 v-if="race.race_link" style="margin-bottom: 3px;">
          <!-- https://www.reddit.com/r/vuejs/comments/4ws0px/why_using_vbindhref_rather_than_a_href_string_a/ -->
          <a :href="race.race_link" target="_blank" style="margin-right: 10px;">{{ race.race_name }}</a>
          <!-- {{ race.race_name }}<a :href="race.race_link" target="_blank" style="margin-right: 10px; margin-left: 8px;"><img src="../../assets/img/icons/link_grey.svg" width='13px' alt="edit" class='mb-1' style="" id=""></a> -->
          <!-- <small @click="showEditModal(race)" style="cursor: pointer; font-size: 14px;">
            {{ race.date }} <img src="../../assets/img/icons/edit_icon_simple.svg" width='12px' alt="edit" class='ml-1 mb-1' style="" id="">
          </small> -->
        </h5>
        <h5 v-if="!race.race_link" style="margin-bottom: 3px;">
          {{ race.race_name }}
          <!-- <small @click="showEditModal(race)" style="cursor: pointer; font-size: 14px; margin-left: 10px; padding-bottom: 10px;">
            {{ race.date }} <img src="../../assets/img/icons/edit_icon_simple.svg" width='12px' alt="edit" class='ml-1 mb-1' style="" id="">
          </small> -->
        </h5>
        <!-- <small @click="showEditModal(race)" style="cursor: pointer;">{{ race.date }} <img src="../../assets/img/icons/edit_icon_simple.svg" width='12px' alt="edit" class='ml-1 mb-1' style="" id=""></small> -->
        <small>{{ race.date }}</small>
        <div class="mt-1">
          <div class="">
            <h5>
              <span class="mr-3" style="font-weight: 700;">
                <span v-if="race.race_type != 'Custom'">{{ race.race_type }}</span><span v-if="race.race_type == 'Custom'">{{ race.distance | singleDecimal }} {{ race.distance_units }}</span><span v-if="race.time_total"> - <span v-if="race.time_hours">{{ race.time_hours }}:</span><span v-if="!race.time_hours">00:</span>{{ race.time_minutes | twoDigits }}:{{ race.time_seconds | singleDecimalSeconds }}<span v-if="race.personal_best">*</span></span>
              </span>
              <span v-if="race.overall_rank" style="" class="mr-3">
                Overall: {{ race.overall_rank }}<span v-if="race.overall_competitors">/</span>{{ race.overall_competitors }}
              </span>
              <span v-if="race.age_rank" style="" class="mr-3">
                Age Category: {{ race.age_rank }}<span v-if="race.age_competitors">/</span>{{ race.age_competitors }}
              </span>
              <small v-if="race.results_link"><a :href="race.results_link" target="_blank">See Results</a></small>
            </h5>
          </div>
          <!-- <div class="col-md-2">
            <h5 v-if="race.total_time">{{ race.time_hours }}:{{ race.time_minutes }}:{{ race.time_seconds }}</h5>
          </div> -->
        </div>
        <!-- <p v-html="rawHtml">{{ race.notes }}</p> -->
        <p v-if="race.notes">{{race.notes}}</p>
        <!-- <span v-html="race.notes"></span> -->
        <!-- {{ race.race_link }} -->
      </div>
      <!-- <hr> -->
    </div>
    </div>

    <!-- ---- EDIT RACE MODAL ---- -->
    <modal name="edit-race" width="90%" height="auto" :scrollable="true" class="field-of-fields" style="z-index: 9999;">
      <div class="p-4" style="">
        <h4 v-if="!editing">Add Past Race</h4>
        <h4 v-if="editing">Edit {{ raceName }}</h4>
        <hr>
        <small>Fields marked with a * are required.</small>
        <form action="" class="">
          <div class="form-row">
            <div class="form-group col-md-6" :class="{ invalid: $v.raceName.$invalid && saveClicked }">
              <label for="raceName">Race Name*</label>
              <input type="text" class="form-control" id="raceName" placeholder="What's the name of the event?" v-model="raceName">
              <small v-if="$v.raceName.$invalid && (updateClicked || saveClicked)">A race name is required.</small>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-3" :class="{ invalid: $v.raceDate.$invalid && saveClicked }">
              <label for="raceDate">Race Date*</label>
              <!-- <div style="line-height: 1;">
                <small>Si no tienes todavía una fecha de inicio, deja este campo en blanco</small>
              </div> -->
              <!-- https://www.npmjs.com/package/vuejs-datepicker -->
              <!-- https://codesandbox.io/s/mpklq49wp -->
              <datepicker class="form-control" placeholder="Select Date" v-model="raceDate" style="padding: .37rem .75rem; line-height: 1;"></datepicker>
              <small v-if="$v.raceDate.$invalid && (updateClicked || saveClicked)">The race date is required.</small>
            </div>
            <!-- ---- INSIDE EDIT RACE MODAL ---- -->
            <div class="form-group col-md-3">
              <label for="raceType">Race Type</label>
              <select class="form-control" id="raceType" v-model="raceType">
                <option>5k</option>
                <option>10k</option>
                <option>Half Marathon</option>
                <option>Marathon</option>
                <option>Custom</option>
              </select>
            </div>
            <!-- <div class="form-group col-md-6">
              <label for="raceType">Race Type</label>
              <select class="form-control" id="raceType" v-model="raceType">
                <option>5k</option>
                <option>10k</option>
                <option>Half Marathon</option>
                <option>Marathon</option>
                <option>Custom</option>
              </select>
            </div> -->
            <!-- https://getbootstrap.com/docs/4.0/components/input-group/ -->
            <div class="form-group col-md-4">
              <label>Finishing Time</label>
              <!-- <div class="form-row">
                <div class="col-lg-4 col-md-4 input-group" style="padding-right: 0;">
                  <input type="number" class="form-control" id="" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 input-group" style="padding-left: 0; padding-right: 0;">
                  <input type="number" class="form-control" id="" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                  <div class="input-group-append">
                    <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4" style="padding-left: 0; padding-right: 30px;">
                  <input type="number" class="form-control" id="" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                </div>
              </div> -->
              <div class="input-group">
                <input type="number" class="form-control" placeholder="hours" v-model="hours" style="border-top-right-radius: 0; border-bottom-right-radius: 0;">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                </div>
                <input type="number" class="form-control" id="" placeholder="mins" v-model="minutes" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">:</span>
                </div>
                <input type="number" class="form-control" placeholder="secs" v-model="seconds" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              </div>
            </div>

            <div class="form-group col-md-2">
              <label for="">Personal Best?</label>
              <div class="ml-1">
                <input type="checkbox" id="PBcheckbox" v-model="personalBest">
                <label for="PBcheckbox" class="ml-1 mt-1">Yes!</label>
              </div>
            </div>
          </div>
          <!-- ---- INSIDE EDIT RACE MODAL ---- -->
          <!-- Allow the user to enter a race distance and units if it isn't one of the standard lengths -->
          <div class="form-row" v-if="raceType == 'Custom'">
            <div class="form-group col-md-6">
              <!-- <label for="raceDistance">Distance</label> -->
              <input type="text" class="form-control" id="raceDistance" placeholder="Distance" v-model="raceDistance">
              <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
            </div>
            <div class="form-group col-md-6" style="max-width: 100px;">
              <select class="form-control" v-model="distanceUnits">
                <option>km</option>
                <option>mi</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-6" :class="{ 'invalid': checkInteger(overallRank) || checkInteger(overallCompetitors) }">
              <label>Overall Rank</label>
              <div class="input-group">
                <input type="text" class="form-control" id="overallRank" v-model="overallRank">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
                </div>
                <input type="text" class="form-control" id="overallCompetitors" placeholder="How many people in the race?" v-model="overallCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              </div>
              <small v-if="checkInteger(overallRank) || checkInteger(overallCompetitors)">Must be an integer!</small>
            </div>
            <!-- <div class="col-lg-3 col-md-6 web-only" style="padding-right: 0;">
              <label for="overallRank">Overall Rank</label>
              <div class="form-group input-group">
                <input type="text" class="form-control" id="overallRank" placeholder="" v-model="overallRank">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 web-only" style="padding-left: 0;">
              <label for="overallCompetitors" style="padding-left: 5px;">Overall Competitors</label>
              <input type="number" class="form-control" id="overallCompetitors" placeholder="How many people in the race?" v-model="overallCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            </div>
            <label class="mobile-only">Overall Rank</label>
            <div class="input-group mobile-only">
              <input type="number" class="form-control" id="overallRank" placeholder="" v-model="overallRank">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
              </div>
              <input type="number" class="form-control" id="overallCompetitors" placeholder="How many people in the race?" v-model="overallCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            </div> -->

            <div class="form-group col-md-6" :class="{ 'invalid': checkInteger(ageRank) || checkInteger(ageCompetitors) }">
              <label>Age Category Rank</label>
              <div class="input-group">
                <input type="text" class="form-control" id="ageRank" v-model="ageRank">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
                </div>
                <input type="text" class="form-control" id="ageCompetitors" placeholder="How many people in your age category?" v-model="ageCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
              </div>
              <small v-if="checkInteger(ageRank) || checkInteger(ageCompetitors)">Must be an integer!</small>
            </div>
            <!-- <div class="col-lg-3 col-md-6 web-only" style="padding-right: 0;">
              <label for="ageRank">Age Category Rank</label>
              <div class="form-group input-group">
                <input type="number" class="form-control" id="ageRank" placeholder="" v-model="ageRank">
                <div class="input-group-append">
                  <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-3 col-md-6 web-only" style="padding-left: 0;">
              <label for="ageCompetitors" style="padding-left: 5px;">Age Category Competitors</label>
              <input type="number" class="form-control" id="ageCompetitors" placeholder="" v-model="ageCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            </div>
            <label for="" class="mobile-only">Age Category Rank</label>
            <div class="input-group mobile-only">
              <input type="number" class="form-control" id="ageRank" placeholder="" v-model="ageRank">
              <div class="input-group-append">
                <span class="input-group-text" id="basic-addon1" style="border-top-right-radius: 0; border-bottom-right-radius: 0; border-right-width: 0;">/</span>
              </div>
              <input type="number" class="form-control" id="ageCompetitors" placeholder="" v-model="ageCompetitors" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
            </div> -->
          </div>
          <!-- ---- INSIDE EDIT RACE MODAL ---- -->
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="raceLink">Race Link</label>
              <input type="text" class="form-control" id="raceLink" placeholder="Link to the race info page" v-model="raceLink">
              <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
            </div>
            <div class="form-group col-md-6">
              <label for="resultsLink">Results Link</label>
              <input type="text" class="form-control" id="resultsLink" placeholder="Link to the race results page" v-model="resultsLink">
              <!-- <small v-if="$v.raceName.$invalid && saveClicked">A race name is required.</small> -->
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="notes">Notes</label>
              <textarea class="form-control" id="notes" rows="3" v-model="notes" placeholder="Anything notworthy about the event or your performance! Weather conditions, any injuries you experienced or were dealing with, people you met, things you learned, etc."></textarea>
            </div>
          </div>
          <!-- <button class="btn btn-primary" @click.prevent="updateRace(editRace.id)">Update</button> -->
        </form>
        <!-- {{ editRace }} -->
        <hr>
        <div class="web-only" v-if="editing">
          <button class="btn btn-info mr-1 mt-2" @click="closeEditModal">Cancel</button><button class="btn btn-danger mr-1 mt-2" @click="deleteRace(editRace.id)" style="">Delete Race</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="updateRace(editRace.id)" style="float: right;">Update Race</button>
        </div>
        <div class="mobile-only" v-if="editing">
          <button class="btn btn-info mr-1 mt-2" @click="closeEditModal">Cancel</button><button class="btn btn-danger mr-1 mt-2" @click="deleteRace(editRace.id)" style="">Delete Race</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="updateRace(editRace.id)" style="float: right;">Update</button>
        </div>
        <div v-if="!editing">
          <button class="btn btn-info mr-1 mt-2" @click="closeEditModal">Cancel</button><button class="btn btn-primary mt-2 mb-4" @click.prevent="saveRace" style="float: right;">Save</button>
        </div>
      </div>
    </modal>
    <!-- ---- END OF EDIT RACE MODAL ---- -->

    <!-- {{ raceDate }} -->
    <!-- {{ randomDate }} -->
    <!-- <p v-if="raceDate">{{ raceDate.value }}</p> -->
    <!-- {{ user }} -->
    <!-- {{ notes }} -->
    <!-- {{ pastRaces }} -->

  </div>

</template>

<script>
  import axios from 'axios'
  import { required } from 'vuelidate/lib/validators'; // Validators pre built into vuelidate - lecture 373
  import Datepicker from 'vuejs-datepicker'; // https://www.npmjs.com/package/vuejs-datepicker

  export default {
    props: ['userID'],
    data () {
      return {
        show: false,
        showEditForm: false,
        raceName: '',
        raceDate: '',
        raceDistance: null,
        distanceUnits: '',
        raceType: '',
        hours: null,
        minutes: null,
        seconds: null,
        totalTime: null,
        overallRank: null,
        overallCompetitors: null,
        ageRank: null,
        ageCompetitors: null,
        raceLink: '',
        resultsLink: '',
        notes: '',
        saveClicked: false,
        updateClicked: false,
        user: null,
        pastRaces: null,
        editRace: null,
        personalBest: false,

        team: '',

        editing: false,
      }
    },
    validations: {
      raceName: {
        required,
      },
      raceDate: {
        required,
      },
    },
    components: {
      Datepicker // https://www.npmjs.com/package/vuejs-datepicker
    },
    created () {
      // this.$store.dispatch('getUser').then(() => { // Lecture 360
      //   this.user = this.$store.getters.user
      //   console.log(this.$store.getters.user)
      // })
      this.getUserProfile();

      this.team = this.$store.getters.team
    },
    // computed () {
    //   // raceDistance
    // },
    methods: {
      // addRace () {
      //   $("#addRaceModal").modal('show');
      // },
      /* ACCORDION https://codepen.io/ktsn/pen/dzNRjx */
      toggle: function() {
        this.show = !this.show;
      },
      toggleEditForm: function(race) {
        // This was when attempting to make the edit form an accordion - not being used
        this.editRace = race
        this.raceName = race.race_name
        this.raceDate = race.date
        this.raceType = race.race_type
        this.raceDistance = race.distance
        this.distanceUnits = race.distance_units
        this.hours = race.time_hours
        this.minutes = race.time_minutes
        this.seconds = race.time_seconds
        this.totalTime = race.time_total
        this.overallRank = race.overall_rank
        this.overallCompetitors = race.overall_competitors
        this.ageRank = race.age_rank
        this.ageCompetitors = race.age_competitors
        this.raceLink = race.race_link
        this.resultsLink = race.results_link
        this.notes = race.notes;
        this.showEditForm = true
      },
      closeEditForm () {
        // This was when attempting to make the edit form an accordion - not being used
        this.showEditForm = false
      },
      beforeEnter: function(el) {
        el.style.height = '0';
      },
      enter: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      beforeLeave: function(el) {
        el.style.height = el.scrollHeight + 'px';
      },
      leave: function(el) {
        el.style.height = '0';
      },
      /* ---- End of Accordion methods --- */
      getUserProfile () {
        // userID is a prop, the idea being that it can be passed in via the coach's dashboard or elsewhere to view anyone's training plan
        // If it's not passed in, then we just get the training plan of whoever is logged in
        if (!this.userID) {
          this.$store.dispatch('getUser').then(() => { // Lecture 360
            this.user = this.$store.getters.user
            this.distanceUnits = this.user.preferred_distance_units
            console.log(this.$store.getters.user)
            this.getPastRaces();
          })
        }
        else {
          axios.get('/api/users/?id='.concat(this.userID))
            .then(res => {
              this.user = res.data[0]
              this.distanceUnits = this.user.preferred_distance_units
              this.getPastRaces();
            })
            .catch(error => console.log(error))
        }
      },
      getPastRaces () {
        axios.get('/api/pastraces/?user='.concat(this.user.id.toString()))
          .then(res => {
            console.log(res)
            this.pastRaces = res.data
          })
          .catch(error => console.log(error))
      },
      calculateDistance () {
        //
        // Figure out the race distance for common, pre-defined race types
        //
        console.log('Calculating distance!')
        console.log(this.distanceUnits)
        if (this.raceType == 'Custom') {
          return
        } else if (this.raceType == '5k' && this.distanceUnits == 'km') {
          this.raceDistance = 5;
        } else if (this.raceType == '5k' && this.distanceUnits == 'mi') {
          this.raceDistance = 3.1;
        } else if (this.raceType == '10k' && this.distanceUnits == 'km') {
          this.raceDistance = 10;
        } else if (this.raceType == '10k' && this.distanceUnits == 'mi') {
          this.raceDistance = 6.2;
        } else if (this.raceType == 'Half Marathon' && this.distanceUnits == 'km') {
          this.raceDistance = 21.1;
        } else if (this.raceType == 'Half Marathon' && this.distanceUnits == 'mi') {
          this.raceDistance = 13.1;
        } else if (this.raceType == 'Marathon' && this.distanceUnits == 'km') {
          this.raceDistance = 42.2;
        } else if (this.raceType == 'Marathon' && this.distanceUnits == 'mi') {
          this.raceDistance = 26.2;
        } else {
          return
        }
      },
      calculateTotalTime() {
        // let totalTime = null
        this.totalTime = null
        if (this.hours) {
          this.totalTime += this.hours * 3600
        }
        if (this.minutes) {
          this.totalTime += this.minutes * 60
        }
        if (this.seconds) {
          this.totalTime += this.seconds
        }
      },
      saveRace () {
        this.saveClicked = true
        console.log(this.raceDate)
        // console.log(this.raceDate.format("isoDate"))
        // let options = { year: 'numeric',  }
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        console.log(this.raceDate.toLocaleDateString("en-US", options)); // 9/17/2016

        if (!this.distanceUnits){
          this.distanceUnits = this.user.preferred_distance_units
        }

        // if (this.raceType == '5k')
        this.calculateDistance();
        this.calculateTotalTime();

        axios.post('/api/pastraces/',
          {
            user: this.user.id, // https://stackoverflow.com/questions/39001486/posting-a-foreign-key-relationship-in-django-rest-framework
            race_name: this.raceName,
            // date: this.raceDate,
            // https://docs.djangoproject.com/en/2.2/ref/forms/fields/#datefield
            date: this.raceDate.toLocaleDateString("en-US", options), // https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date, https://www.django-rest-framework.org/api-guide/fields/#datefield
            // date: '10/01/2019', // This is the kind of format the above expression is outputting
            // date: '2019-01-29', // This is the default format django rest framework expects
            race_type: this.raceType,
            distance: this.raceDistance,
            distance_units: this.distanceUnits,
            time_hours: this.hours,
            time_minutes: this.minutes,
            time_seconds: this.seconds,
            time_total: this.totalTime,
            overall_rank: this.overallRank,
            overall_competitors: this.overallCompetitors,
            age_rank: this.ageRank,
            age_competitors: this.ageCompetitors,
            race_link: this.raceLink,
            results_link: this.resultsLink,
            notes: this.notes,
            personal_best: this.personalBest,
          }
        )
          .then(res => {
            console.log(res)
            this.getPastRaces() // Refresh the list of races after adding a new one
            this.clearRaceForm()
            this.closeEditModal() // Close the race modal
            this.show = false // Close the add race accordion
            this.saveClicked = false
          })
          .catch(error => console.log(error))
      },
      updateRace (raceID) {
        console.log('Updating race: '.concat(raceID.toString()))
        this.updateClicked = true

        if (!this.distanceUnits){
          this.distanceUnits = this.user.preferred_distance_units
        }

        this.calculateDistance();
        this.calculateTotalTime();
        console.log(this.raceDate)
        console.log(new Date(this.raceDate))
        // When pulling the date from the database, it's in the YYYY-MM-DD format
        // So when we try to run toLocaleDateString on it, it doesn't work because it expects a javascript date object
        // So we convert the date to a javascript date object to ensure we can convert it back without issues later
        this.raceDate = new Date(this.raceDate)
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        console.log(this.raceDate.toLocaleDateString("en-US", options));

        console.log(this.raceName)
        console.log(this.raceDate.toLocaleDateString("en-US", options))
        console.log(this.raceType)
        console.log(this.raceDistance)
        console.log(this.distanceUnits)
        console.log(this.hours)
        console.log(this.minutes)
        console.log(this.seconds)
        console.log(Math.round(this.totalTime * 100) / 100)
        console.log(this.overallRank)
        console.log(this.overallCompetitors)
        console.log(this.ageRank)
        console.log(this.ageCompetitors)
        console.log(this.raceLink)
        console.log(this.resultsLink)
        console.log(this.notes)
        console.log(this.personalBest)

        axios.patch('/api/pastraces/'.concat(raceID.toString()).concat('/'),
          {
            race_name: this.raceName,
            date: this.raceDate.toLocaleDateString("en-US", options), // https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date, https://www.django-rest-framework.org/api-guide/fields/#datefield
            race_type: this.raceType,
            distance: this.raceDistance,
            distance_units: this.distanceUnits,
            time_hours: this.hours == '' ? null : this.hours, // Can't post an empty string to an integer field
            time_minutes: this.minutes,
            time_seconds: this.seconds,
            // When the total time is calculated, it outputs some weird floating point number
            time_total: Math.round(this.totalTime * 100) / 100, // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary
            overall_rank: this.overallRank,
            overall_competitors: this.overallCompetitors,
            age_rank: this.ageRank,
            age_competitors: this.ageCompetitors,
            race_link: this.raceLink,
            results_link: this.resultsLink,
            notes: this.notes,
            personal_best: this.personalBest,

            // user: 2 // Hard coded this here because I accidentally saved stuff to the wrong user and didn't want to enter it again
          }
        )
          .then(res => {
            console.log(res)
            this.getPastRaces() // Refresh the list of races after adding a new one
            this.clearRaceForm()
            this.closeEditModal() // Close the edit race modal
            this.updateClicked = false
          })
          .catch(error => {
            console.log(error)
          })
      },
      showModal() {
        this.clearRaceForm()
        this.editing = false
        this.$modal.show('edit-race'); // npmjs.com/package/vue-js-modal
      },
      showEditModal(race) {
        this.editRace = race
        this.raceName = race.race_name
        this.raceDate = race.date
        this.raceDate = new Date(this.raceDate)
        this.raceType = race.race_type
        this.raceDistance = race.distance
        this.distanceUnits = race.distance_units
        this.hours = race.time_hours
        this.minutes = race.time_minutes
        this.seconds = race.time_seconds
        this.totalTime = race.time_total
        this.overallRank = race.overall_rank
        this.overallCompetitors = race.overall_competitors
        this.ageRank = race.age_rank
        this.ageCompetitors = race.age_competitors
        this.raceLink = race.race_link
        this.resultsLink = race.results_link
        this.notes = race.notes;
        this.personalBest = race.personal_best;
        this.$modal.show('edit-race'); // npmjs.com/package/vue-js-modal
        this.editing = true
      },
      closeEditModal() {
        this.$modal.hide('edit-race'); // npmjs.com/package/vue-js-modal
        this.clearRaceForm()
      },
      deleteRace(raceID) {
        console.log(raceID)
        axios.delete('/api/pastraces/'.concat(raceID.toString()).concat('/'))
          .then(res => {
            console.log(res)
            this.getPastRaces() // Refresh the list of races after deleting one
            this.$modal.hide('edit-race'); // npmjs.com/package/vue-js-modal
          })
          .catch(error => console.log(error))
      },
      clearRaceForm() {
        this.raceName = ''
        this.raceDate = ''
        this.raceType = ''
        this.raceDistance = null
        this.distanceUnits = ''
        this.hours = null
        this.minutes = null
        this.seconds = null
        this.totalTime = null
        this.overallRank = null
        this.overallCompetitors = null
        this.ageRank = null
        this.ageCompetitors = null
        this.raceLink = ''
        this.resultsLink = ''
        this.notes = ''
        this.personalBest = false
      }
    },
  }
</script>

<style>

  .PB {
    background-color: #bfe7ff;
  }

  .notPB {
    background-color: var(--bootstrapgrey);
  }

  /* --- MOVED ALL THE STYLING TO APP.VUE ---  */
  /* .accordion {
    font-family: Lato;
    margin-bottom: 8px;

    background-color: var(--coredarkcolor);
    border-radius: 3px;
  } */

  /* .accordion .header {
    height: 40px;
    line-height: 40px;
    padding: 0 40px 0 8px;
    position: relative;
    color: #fff;
    cursor: pointer;
    font-weight: 700;
    font-size: 17px;
  } */

  /* .accordion .header-icon {
    position: absolute;
    top: 5px;
    right: 8px;
    transform: rotate(0deg);
    transition-duration: 0.3s;
  } */

  /* .accordion .body {
    overflow: hidden;
    background-color: #fff;
    border-top: 0;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    transition: 250ms ease-out;
  } */

  /* .accordion .body-inner { */
    /* padding: 8px; */
    /* overflow-wrap: break-word; */
  /*   white-space: pre-wrap; */
    /* Need to add extra padding at the bottom because if new items appear (like error messages or custom distance fields, the accordion doesn't change size to accomodate them) */
    /* padding-bottom: 110px; */
  /* } */

  /* Not Used */
  /* .accordion .header-icon.rotate {
    transform: rotate(180deg);
    transition-duration: 0.3s;
  } */

  /* form label {
    font-weight: 700;
    margin-bottom: 3px;
    margin-top: 10px;
    color: #2F4F4F;
  } */

  /* Classes that get attached to form fields that fail vuelidation */
  /* .invalid label {
    color: red;
  }
  .invalid small {
    color: red;
  } */

  /* MOVED TO APP.VUE */
  /* .vdp-datepicker input {
    border-width: 0px;
  } */
  .vdp-datepicker input[type="text"]:focus {
    /* box-shadow: none; */
    /* border: none; */
    /* border-color: transparent; */
    /* border-width: 0; */
  }
  /* .vdp-datepicker__calendar input[type="text"]:focus {
    box-shadow: none;
    border: none;
  }
  .vdp-datepicker__calendar {
    border: none;
  } */
</style>



// WEBPACK FOOTER //
// src/components/myrundash/RaceLog.vue